// client/ui/CAdminCourseAssistantCoPilot.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class CAdminCourseAssistantCoPilot extends ComponentBase {
    constructor(config) {
        super(config);
        this.coPilotComponent = null;
    }

    async initialize() {
        await super.initialize();
    }

    async initAfterLogin() {
        const agentName = "CourseAssistantAgent";
        const courseAdminUserId = this.appClient.getSharedData('userId'); // Get the logged-in user's ID

        if (!courseAdminUserId) {
            this.log.error("CAdminCourseAssistantCoPilot: Cannot initialize AiCoPilot without the CourseAdmin's userId.");
            if (this.container) { // Only attempt to render error if container exists
                 this.container.innerHTML = `<p class="p-3 text-danger">${this.t('Error: User context not available for Assistant.')}</p>`;
                 this.appClient.tx.applyTranslations(this.container);
            }
            return;
        }

        this.coPilotComponent = await this.createManagedComponent(
            'AdvancedAIWorkspace',
            null,
            {
                instanceId: `${this.config.instanceId || 'cadminAssistant'}-aicopilot`,
                agentName: agentName,
                singleAgentMode: true,
                height: 'container'
            }
        );

        // Re-render if the container already exists (e.g., if initAfterLogin was called after initial render)
        if (this.container) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'cadmin-course-assistant-copilot-container h-100 d-flex flex-column';
        }
        this.container.innerHTML = '';

        if (this.coPilotComponent) {
            this.container.appendChild(await this.coPilotComponent.render());
        } else {
            // This might show if initAfterLogin hasn't completed or failed to create coPilotComponent
            const loadingOrErrorDiv = document.createElement('div');
            loadingOrErrorDiv.className = 'p-3 text-center text-muted';
            if (!this.appClient.getSharedData('userId')) {
                 loadingOrErrorDiv.textContent = this.t('Error: User context not available for Assistant.');
                 loadingOrErrorDiv.classList.add('text-danger');
            } else {
                loadingOrErrorDiv.textContent = this.t('Loading Course Assistant...');
            }
            this.container.appendChild(loadingOrErrorDiv);
        }
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        this.coPilotComponent?.destroy();
        this.coPilotComponent = null;
        super.destroy();
    }
}